import { CONSTANTS } from '@/project/configs/configs'

export const MAP_CONFIG = {
  defaultMapProvider: 'google', // 'google' ou 'nominatim'
  defaultGeocodeProvider: 'nominatim', // 'google' ou 'nominatim'
  googleApiKey: CONSTANTS.GOOGLE_MAP_API_KEY,
  nominatimUrl: 'https://nominatim.openstreetmap.org/reverse',
}
